import React from "react";

import dynamic from "next/dynamic";
const DynamicHeader = dynamic(() => import("./../Header"), {
  ssr: false
});

const Layout = ({
  restaurantNotReady,
  screenDesktop,
  idRestaurant,
  onlineStatus,
  openService,
  isInIframe,
  children,
  slogan,
  name,
  path
}) => {
  const pathIsCart = path.includes("panier") && !screenDesktop;
  return (
    <div
      className={`container user-container ${pathIsCart ? "path-cart" : ""}`}
    >
      <DynamicHeader
        className="container is-fluid"
        restaurantNotReady={restaurantNotReady}
        isOpenService={openService}
        idRestaurant={idRestaurant}
        isOnline={onlineStatus}
        isInIframe={isInIframe}
        slogan={slogan}
        name={name}
        hash={path}
      />

      {children}
    </div>
  );
};

export default Layout;
